let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("fliVL"), load("eVTNs")]).then(() => parcelRequire('k2J4N'));